'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import ResultHeader from './ResultHeader';
import ResultInfo from './ResultInfo';
import GradeTypeConstants from '../../constants/GradeTypeConstants';
import classNames from 'classnames';
export default class IconResultSection extends Component {
  constructor(...args) {
    super(...args);

    this.getTickOrXIconClasses = () => {
      const {
        gradeType
      } = this.props;
      return classNames("icon", gradeType === GradeTypeConstants.GOOD && 'icon-check-circle', gradeType === GradeTypeConstants.BAD && 'icon-delete-circle');
    };
  }

  render() {
    const {
      props
    } = this;
    return /*#__PURE__*/_jsxs("div", {
      className: "flip-card-container",
      children: [/*#__PURE__*/_jsx("div", {
        className: "left",
        children: /*#__PURE__*/_jsx("div", {
          className: this.getTickOrXIconClasses()
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "info",
        children: [/*#__PURE__*/_jsx(ResultHeader, Object.assign({}, props)), /*#__PURE__*/_jsx(ResultInfo, Object.assign({}, props))]
      })]
    });
  }

}
IconResultSection.propTypes = {
  gradeType: PropTypes.string,
  resultHeader: PropTypes.string,
  resultIcon: PropTypes.string
};